<p i18n>Alexander Schwartz<br>
  Normannenstr. 6<br>
  81925 München<br>
  Email: <a href="mailto:aSchwartz@blitzshare.de">aSchwartz@blitzshare.de</a><br>
  Telefon: +49 (0) 171 / 5432107<br>
  Umsatzsteuer-Identifikationsnummer: DE270827078<br>
